const configValue = {
   downloadUrlAndroid: 'https://play.google.com/store/apps/details?id=com.lovense.wear',
   evokeAndroidAppUrl: "wear://remote/date?controllink=#parameter",
   evokeIosAppUrl: "https://lovense.club/remote/camapi/clEvokeApp.html?&qrcode=#parameter&time=5000",
   pcTestEnvControlLinkUrl: "https://test10.lovense.com/c/#parameter",
   pcprodEnvControlLinkUrl: "https://c.lovense.com/c/#parameter",
}
export default configValue;
